/* eslint-disable react/no-unknown-property */
import React from 'react';
import { useParams } from 'react-router-dom';
import LoadPlanViewer3D from './LoadPlanViewer3D';

export default function LoadPlanViewerFullScreen() {
  const { id } = useParams();
  const warehouseOutId = id ? Number(id) : null;

  return (
    <div style={{
      width: '100%', height: '100vh', margin: 0, padding: 0,
    }}
    >
      <LoadPlanViewer3D warehouseOutId={warehouseOutId} height="100vh" />
    </div>
  );
}
